import type { DeletableEntity } from '../config';

export const isDeleted = (entity: DeletableEntity) =>
  entity.Deleted?.Deleted === true;
